module.exports = __webpack_public_path__ + "img/006.16321189.png";